import PropTypes from 'prop-types';
import React from 'react';

import ProgressIndicator from '../../../../../components/ProgressIndicator';
import {
  formatarMilhar,
  formatarPorcentagemSufixoEsquerda,
} from '../../../../../helpers/formatador';
import { CampoLote, CampoLoteLabel } from '../styles';
import Card from './Card';
import {
  CampoLoteExtraStyle,
  CampoLoteLabelExtraStyle,
  CardContainer,
  LeftLabel,
  ProgressContainer,
} from './styles';

const Compilados = ({ compilados }) => (
  <CardContainer>
    <Card title="Volume" content={`${formatarMilhar(compilados.volume)} ton`} />
    <Card title="Saldo" content={`${formatarMilhar(compilados.saldo)} ton`} />
    <Card
      title="Cadência do dia"
      content={`${formatarMilhar(compilados.cadenciaDia)} ton`}
    />
    <Card>
      <CampoLote style={CampoLoteExtraStyle}>
        <CampoLoteLabel style={CampoLoteLabelExtraStyle}>
          {`Aderência do dia (${compilados.cotas} cotas)`}
        </CampoLoteLabel>
        <ProgressContainer>
          <LeftLabel>
            {`${formatarPorcentagemSufixoEsquerda(
              `${compilados.aderenciaDiaPercentual}`,
              '',
              2,
              ''
            )}%`}
          </LeftLabel>
          <ProgressIndicator
            progress={compilados.aderenciaDiaPercentual}
            label={`${formatarMilhar(compilados.aderenciaDiaTon)} ton`}
          />
        </ProgressContainer>
      </CampoLote>
    </Card>
  </CardContainer>
);

export default Compilados;

Compilados.propTypes = {
  compilados: PropTypes.shape({
    volume: PropTypes.number,
    saldo: PropTypes.number,
    cadenciaDia: PropTypes.number,
    aderenciaDiaPercentual: PropTypes.number,
    aderenciaDiaTon: PropTypes.number,
    aderenciaDia: PropTypes.number,
    cotas: PropTypes.number,
  }).isRequired,
};
